import { Spinner } from "@/external/ensolvers-core-frontend-mui-v5/components/Common/Spinner";
import { Box } from "@mui/material";

export function FullscreenLoading() {
  return (
    <Box
      sx={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        zIndex: 100000,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Spinner size={"2rem"} />
    </Box>
  );
}
